import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import styled from 'styled-components';

const CursorWrapper = styled.div`
  @media (max-width: 768px) {
    display: none; // Disable custom cursor on mobile touch devices
  }
`;

const CursorDot = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  background-color: var(--accent-primary);
  border-radius: 50%;
  pointer-events: none;
  z-index: 10000;
  transform: translate(-50%, -50%);
  mix-blend-mode: exclusion;
`;

const CursorOutline = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(59, 130, 246, 0.5);
  border-radius: 50%;
  pointer-events: none;
  z-index: 9999;
  transform: translate(-50%, -50%);
  transition: width 0.2s, height 0.2s, background-color 0.2s;
  
  &.hovering {
    width: 60px;
    height: 60px;
    background-color: rgba(59, 130, 246, 0.1);
    border-color: transparent;
    backdrop-filter: blur(2px);
  }
`;

const CustomCursor = () => {
    const [isHovering, setIsHovering] = useState(false);

    // Mouse position values
    const mouseX = useMotionValue(0);
    const mouseY = useMotionValue(0);

    // Smooth springs for the trailing outline
    const springConfig = { damping: 25, stiffness: 300, mass: 0.5 };
    const cursorXSpring = useSpring(mouseX, springConfig);
    const cursorYSpring = useSpring(mouseY, springConfig);

    useEffect(() => {
        const moveCursor = (e) => {
            // Immediate update for the dot
            mouseX.set(e.clientX - 6); // offset by half width
            mouseY.set(e.clientY - 6);
        };

        const handleMouseOver = (e) => {
            const target = e.target;
            // Check if we are hovering over something interactive
            if (
                target.tagName.toLowerCase() === 'a' ||
                target.tagName.toLowerCase() === 'button' ||
                target.closest('a') ||
                target.closest('button') ||
                target.classList.contains('interactive')
            ) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener('mousemove', moveCursor);
        window.addEventListener('mouseover', handleMouseOver);

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            window.removeEventListener('mouseover', handleMouseOver);
        };
    }, [mouseX, mouseY]);

    return (
        <CursorWrapper>
            <CursorDot
                style={{
                    x: mouseX,
                    y: mouseY,
                    scale: isHovering ? 0 : 1
                }}
                transition={{ type: "tween", ease: "backOut", duration: 0.1 }}
            />
            <CursorOutline
                className={isHovering ? 'hovering' : ''}
                style={{
                    x: cursorXSpring,
                    y: cursorYSpring,
                }}
            />
        </CursorWrapper>
    );
};

export default CustomCursor;
